exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".links-435896df{padding:20px}.links-435896df a{font-weight:500;font-size:13px;margin-right:30px}\n", ""]);

// Exports
exports.locals = {
	"links": "links-435896df"
};